import Form from "./../../constant/Forms";

export default {
  name: "ChooseFormTypeComponent",
  components: {
    RegistrationFormComponent: require("../RegistrationFormComponent/RegistrationFormComponent.vue")
      .default,
    ChangePasswordComponent: require("../ChangePasswordComponent/ChangePasswordComponent.vue")
      .default,
  },
  props: {
    user: String,
    isSafari: String,
  },
  data() {
    return {
      formTypes: {
        registration: "Rejestracja",
        changePassword: "Zmiana hasła",
      },
      showPassword: false,
      showRepeatPassword: false,
      returnButtonName: "Wróć",
      submitButtonName: "",
      showRegistrationButton: true,
    };
  },
  methods: {
    properDisplay() {
      if (this.user == undefined) this.$router.push("/");
      // if (this.user == "foreignStudent" || this.user == "polishStudent") {
      //   this.$delete(this.formTypes, "registration");
      // }
    },

    getSelectedComponentName(formType) {
      if (formType == "registration") return "RegistrationFormComponent";
      else if (formType == "changePassword") return "ChangePasswordComponent";
    },

    namesTranslation() {
      if (this.user == "foreignStudent") this.returnButtonName = "Back";

      if (this.user == "foreignStudent") {
        this.formTypes.registration = "Registration";
        this.formTypes.changePassword = "Password change";
      }
    },

    getInfoText() {
      if (this.user == "foreignStudent") return "CHOOSE PROPER FORM TYPE";
      else if (this.user == "polishStudent")
        return "Wybierz odpowiedni rodzaj formularza";
      else return "Wybierz odpowiedni rodzaj formularza";
    },
  },
  created() {
    this.properDisplay();
    this.namesTranslation();

    Form.EMPLOYEE_FORM.valid = false;
    Form.POLISH_STUDENT_FORM.valid = false;
    Form.FOREIGN_STUDENT_FORM.valid = false;
  },
};
